import { render, staticRenderFns } from "./FormQuestionComponent.vue?vue&type=template&id=c1306b9a&scoped=true&"
import script from "./FormQuestionComponent.vue?vue&type=script&lang=ts&"
export * from "./FormQuestionComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FormQuestionComponent.vue?vue&type=style&index=0&id=c1306b9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1306b9a",
  null
  
)

export default component.exports